import { render } from "./ElectionCommView.vue?vue&type=template&id=7957403e&scoped=true"
import script from "./ElectionCommView.vue?vue&type=script&lang=js"
export * from "./ElectionCommView.vue?vue&type=script&lang=js"

import "./ElectionCommView.vue?vue&type=style&index=0&id=7957403e&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7957403e"]])

export default __exports__